import { Button } from "@/components/ui/button";
import { ITicketToAssign } from "@/pages/orders/schemas/ticket-to-assign";
import { ExternalLinkIcon } from "lucide-react";
import { PropsWithChildren } from "react";

export function TicketCard(
  props: PropsWithChildren<{
    idx: number;
    order: any;
    ticket: ITicketToAssign | Partial<ITicketToAssign>;
    onRemove?: (id: number) => void;
  }>,
) {
  const { idx, order, ticket, onRemove, children } = props;
  return (
    <div key={idx} className="flex flex-row w-full gap-1 items-center">
      <div className="text-xl">{idx + 1}</div>
      <div className="flex flex-row gap-2 bg-foreground text-background p-2 rounded-lg w-full">
        {ticket.qrCode && (
          <img
            className="w-20 h-20"
            src={`https://api.qrserver.com/v1/create-qr-code/?size=91x91&data=${ticket.qrCode}" `}
          />
        )}
        <div className="flex flex-col gap-0">
          <div className="font-bold">ID</div>
          <div>{ticket.id}</div>
          <div className="font-bold">Name</div>
          <div>{ticket.name}</div>
          <div className="font-bold">Price</div>
          <div>{ticket.price}</div>
        </div>
        <div className="flex-1" />
        <div className="flex flex-col gap-2 w-1/4">
          {ticket.url && (
            <Button
              className="self-center bg-background text-foreground w-full"
              variant={"ghost"}
              onClick={() => {
                window.open(ticket.url, "_blank");
              }}
            >
              <ExternalLinkIcon className="w-4 h-4" />
              Open URL
            </Button>
          )}
          {children}
          {onRemove && (
            <Button
              className="self-center bg-background text-foreground w-full gap-1"
              variant={"destructive"}
              onClick={() => {
                onRemove?.(idx);
              }}
            >
              Remove
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
